<template>
  <Toast/>
  <div class="relative flex flex-col lg:flex-row gap-6 min-h-screen bg-surface-50 dark:bg-surface-950 p-4 sm:p-6">
    <div id="app-sidebar-14" class="h-full hidden lg:block lg:static absolute left-0 top-0 py-4 pl-4 lg:p-0 z-50">
      <div
          class="w-[18rem] h-full flex flex-col bg-surface-100  border-surface-300 dark:bg-surface-900 rounded-2xl border border-surface-100 dark:border-surface-800">
        <a class="inline-flex items-center gap-3 px-6 py-4 cursor-pointer">

          <svg class="fill-surface-900 dark:fill-surface-0" width="42" height="40"
               viewBox="0 0 32 32"
               fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.84219 2.87829C5.69766 3.67858 4.6627 4.62478 3.76426 5.68992C7.4357 5.34906 12.1001 5.90564 17.5155 8.61335C23.2984 11.5047 27.955 11.6025 31.1958 10.9773C30.9017 10.087 30.5315 9.23135 30.093 8.41791C26.3832 8.80919 21.6272 8.29127 16.0845 5.51998C12.5648 3.76014 9.46221 3.03521 6.84219 2.87829ZM27.9259 5.33332C24.9962 2.06 20.7387 0 16 0C14.6084 0 13.2581 0.177686 11.9709 0.511584C13.7143 0.987269 15.5663 1.68319 17.5155 2.65781C21.5736 4.68682 25.0771 5.34013 27.9259 5.33332ZM31.8887 14.1025C27.9735 14.8756 22.567 14.7168 16.0845 11.4755C10.024 8.44527 5.20035 8.48343 1.94712 9.20639C1.7792 9.24367 1.61523 9.28287 1.45522 9.32367C1.0293 10.25 0.689308 11.2241 0.445362 12.2356C0.705909 12.166 0.975145 12.0998 1.25293 12.0381C5.19966 11.161 10.7761 11.1991 17.5155 14.5689C23.5761 17.5991 28.3997 17.561 31.6529 16.838C31.7644 16.8133 31.8742 16.7877 31.9822 16.7613C31.9941 16.509 32 16.2552 32 16C32 15.358 31.9622 14.7248 31.8887 14.1025ZM31.4598 20.1378C27.5826 20.8157 22.3336 20.5555 16.0845 17.431C10.024 14.4008 5.20035 14.439 1.94712 15.1619C1.225 15.3223 0.575392 15.5178 0.002344 15.7241C0.000781601 15.8158 0 15.9078 0 16C0 24.8366 7.16344 32 16 32C23.4057 32 29.6362 26.9687 31.4598 20.1378Z"
                class="fill-surface-900 dark:fill-surface-0"
            />
          </svg>
          <span class="font-bold text-2xl text-surface-900 dark:text-surface-0">AELIOS</span>
        </a>
        <div class="w-[calc(100%-3rem)] mx-auto h-px bg-surface-200 dark:bg-surface-700 px-6"/>
        <div class="p-6 flex-1 overflow-y-auto">
          <ul class="flex flex-col gap-2">

            <!-- ### START LEFT MENU NAVIGATION ### -->
            <template v-for="(item, navIndex) in navs" :key="navIndex">

              <li v-if="item.type === 'header'" class="px-3 mt-6 mb-1">
                <span class="text-xs font-bold text-gray-500 uppercase tracking-wide">
                  {{ item.label }}
                </span>
              </li>

              <!-- DROPDOWN -->
              <li v-else-if="item.subMenu">
                <div
                    :class="[
            selectedNav === item.label
              ? 'bg-surface-0 dark:bg-surface-950 text-black dark:text-white border-surface shadow-sm'
              : 'border-transparent hover:border-surface-200 dark:hover:border-surface-800 hover:bg-surface-0 dark:hover:bg-surface-950 text-gray-500 dark:text-gray-400',
            'z-30 relative flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer transition-all border'
          ]"
                    @click="selectNav(item.label)"
                >
                  <LucideIcon :name="item.icon" />
                  <span class="flex-1 font-medium">{{ item.label }}</span>
                  <i class="pi pi-chevron-down text-sm leading-none"/>
                </div>

                <Transition name="slide">
                  <div
                      v-if="selectedNav === item.label"
                      class="pl-2 flex flex-col mt-1"
                  >
                    <template v-for="(subItem, subIndex) in item.subMenu" :key="subIndex">
                      <router-link
                          :to="subItem.route"
                          custom
                          v-slot="{ navigate, isActive }"
                      >
                        <div
                            class="cursor-pointer relative px-4 py-2 flex items-center transition-all"
                            @click="selectSubNav(navIndex, subItem.label); navigate($event)"
                        >
                          <svg width="18" height="44" viewBox="0 0 18 44" fill="none" xmlns="http://www.w3.org/2000/svg"
                               class="absolute left-4 -top-2">
                            <path
                                :d="getLinePath(subIndex, item.subMenu.length)"
                                class="stroke-gray-500 dark:stroke-gray-400"
                                stroke-width="2"
                            />
                            <path
                                d="M11.136 26.2862L11.1313 26.2863C11.1243 26.2863 11.1174 26.2849 11.1109 26.2823C11.1045 26.2796 11.0986 26.2756 11.0937 26.2707L11.0937 26.2707L11.0917 26.2687C11.0805 26.2575 11.0742 26.2422 11.0742 26.2263C11.0742 26.2105 11.0805 26.1953 11.0917 26.1841C11.0917 26.184 11.0917 26.184 11.0917 26.184L14.4286 22.8471L14.7822 22.4936L14.4286 22.14L11.1009 18.8123C11.0922 18.8014 11.0875 18.7878 11.0877 18.7737C11.088 18.7582 11.0943 18.7434 11.1052 18.7324C11.1162 18.7214 11.131 18.7151 11.1466 18.7149C11.1606 18.7146 11.1743 18.7193 11.1852 18.7281L14.9083 22.4512C14.9195 22.4625 14.9258 22.4777 14.9258 22.4936C14.9258 22.5095 14.9195 22.5247 14.9083 22.5359L11.1758 26.2685L11.1758 26.2685L11.1736 26.2707C11.1687 26.2756 11.1628 26.2796 11.1564 26.2823C11.1499 26.2849 11.143 26.2863 11.136 26.2862Z"
                                class="stroke-gray-500 fill-gray-500 dark:stroke-gray-400 dark:fill-gray-400"
                            />
                            <path
                                d="M1 14V17.5C1 20.2614 3.23858 22.5 6 22.5H15"
                                class="stroke-gray-500 dark:stroke-gray-400"
                                stroke-width="2"
                            />
                            <template v-if="subIndex === getSelectedIndex(navIndex)">
                              <path
                                  d="M11.136 26.2862L11.1313 26.2863C11.1243 26.2863 11.1174 26.2849 11.1109 26.2823C11.1045 26.2796 11.0986 26.2756 11.0937 26.2707L11.0937 26.2707L11.0917 26.2687C11.0805 26.2575 11.0742 26.2422 11.0742 26.2263C11.0742 26.2105 11.0805 26.1953 11.0917 26.1841C11.0917 26.184 11.0917 26.184 11.0917 26.184L14.4286 22.8471L14.7822 22.4936L14.4286 22.14L11.1009 18.8123C11.0922 18.8014 11.0875 18.7878 11.0877 18.7737C11.088 18.7582 11.0943 18.7434 11.1052 18.7324C11.1162 18.7214 11.131 18.7151 11.1466 18.7149C11.1606 18.7146 11.1743 18.7193 11.1852 18.7281L14.9083 22.4512C14.9195 22.4625 14.9258 22.4777 14.9258 22.4936C14.9258 22.5095 14.9195 22.5247 14.9083 22.5359L11.1758 26.2685L11.1758 26.2685L11.1736 26.2707C11.1687 26.2756 11.1628 26.2796 11.1564 26.2823C11.1499 26.2849 11.143 26.2863 11.136 26.2862Z"
                                  class="stroke-black fill-black dark:stroke-white dark:fill-white"
                              />
                              <path
                                  d="M1 14V17.5C1 20.2614 3.23858 22.5 6 22.5H15"
                                  class="stroke-black dark:stroke-white"
                                  stroke-width="2"
                              />
                            </template>
                            <path
                                v-if="subIndex <= getSelectedIndex(navIndex)"
                                :d="getActiveLinePath(subIndex, getSelectedIndex(navIndex))"
                                class="stroke-black dark:stroke-white"
                                stroke-width="2"
                            />
                          </svg>
                          <span
                              class="leading-relaxed font-medium text-sm transition-all ml-8"
                              :class="isActive || selectedSubNav[navIndex] === subItem.label ? 'text-black dark:text-white' : 'text-gray-500 dark:text-gray-400 hover:text-black dark:hover:text-white'"
                          >{{ subItem.label }}</span>
                        </div>
                      </router-link>
                    </template>
                  </div>
                </Transition>
              </li>

              <li v-else-if="!item.subMenu && !item.type">
                <router-link
                    :to="item.route"
                    custom
                    v-slot="{ navigate, isActive }"
                >
                  <div
                      :class="[
              isActive || selectedNav === item.label
                ? 'bg-surface-0 dark:bg-surface-950 text-black dark:text-white border-surface shadow-sm'
                : 'border-transparent hover:border-surface-200 dark:hover:border-surface-800 hover:bg-surface-0 dark:hover:bg-surface-950 text-gray-500 dark:text-gray-400',
              'z-30 relative flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer transition-all border'
            ]"
                      @click="selectNav(item.label); navigate($event)"
                  >
                    <LucideIcon :name="item.icon" />
                    <span class="flex-1 font-medium">{{ item.label }}</span>
                  </div>
                </router-link>
              </li>
            </template>
            <!-- ### END LEFT MENU NAVIGATION ### -->
          </ul>
        </div>
        <div class="w-[calc(100%-3rem)] mx-auto h-px bg-surface-200 dark:bg-surface-700 px-6"/>

        <!-- ### BOTTOM SLIDING PANEL ### -->
        <div class="mt-auto">
          <hr class="mb-4 mx-4 border-t border-0 border-surface-100 dark:border-surface-800"/>
          <ul class="list-none p-2 m-0 hidden origin-bottom animate-duration-150 overflow-hidden animate-ease-in-out">
            <li>
              <RouterLink :to="`/portal/employee-details/${auth.user?.employeeId}`">
                <div
                    class="flex items-center cursor-pointer p-4 hover:bg-surface-200 dark:hover:bg-surface-800 rounded-border duration-150 transition-colors">
                  <LucideIcon name="IdCardLanyard" class="mr-2" />
                  <span class="font-medium">Profile</span>
                </div>
              </RouterLink>
            </li>

            <li>
              <RouterLink to="/portal/user-guide">
                <div
                    class="flex items-center cursor-pointer p-4 hover:bg-surface-200 dark:hover:bg-surface-800 rounded-border duration-150 transition-colors">
                  <LucideIcon name="BookOpen" class="mr-2" />
                  <span class="font-medium">User Guide</span>
                </div>
              </RouterLink>
            </li>
            <li>
              <a class="flex items-center cursor-pointer p-4 hover:bg-red-500 dark:hover:bg-red-400 hover:text-white rounded-border duration-150 transition-colors"
                 @click="logout">
                <LucideIcon name="LogOut" class="mr-2" />
                <span class="font-medium">Sign Out</span>
              </a>
            </li>
          </ul>
          <a
              v-styleclass="{
                            selector: '@prev',
                            enterFromClass: 'hidden',
                            enterActiveClass: 'animate-slidedown',
                            leaveToClass: 'hidden',
                            leaveActiveClass: 'animate-slideup'
                        }"
              class="m-4 px-2 py-2 flex items-center hover:bg-surface-200 dark:hover:bg-surface-800  rounded-border cursor-pointer duration-150 transition-colors"
          >
            <Avatar
                icon="pi pi-user" severity="danger"
                size="large" class="me-4"
                style="background: linear-gradient(135deg, var(--p-orange-400), var(--p-orange-700)); color: #fff;"/>
            <div>
              <div class="text-sm font-semibold text-surface-900 dark:text-surface-0">
                {{ auth.user?.firstname + " " + auth.user?.lastname }}
              </div>
              <span class="text-sm text-surface-600 dark:text-surface-400 leading-none">{{
                  auth.user?.companyName
                }}</span>
            </div>
            <i class="pi pi-chevron-up !text-xl !leading-none ml-auto"/>
          </a>
        </div>
        <!-- ### END BOTTOM SLIDING PANEL ### -->
      </div>
    </div>

    <div class="flex-1 flex flex-col gap-6">
      <div
          class="flex sm:items-center flex-wrap sm:flex-row flex-col lg:px-5 pt-3 pb-4 justify-between border-b border-surface gap-4">
        <div class="flex items-center gap-2">
          <a
              v-styleclass="{
                            selector: '#app-sidebar-14',
                            enterFromClass: 'hidden',
                            enterActiveClass: 'animate-fadeinleft',
                            leaveToClass: 'hidden',
                            leaveActiveClass: 'animate-fadeoutleft',
                            hideOnOutsideClick: true
                        }"
              class="cursor-pointer block lg:hidden text-surface-700 dark:text-surface-100 mr-2"
          >
            <i class="pi pi-bars text-3xl"/>
          </a>
          <div class="flex-1">
            <h1 class="text-lg font-medium text-surface-900 dark:text-surface-0">
              {{ auth.user?.companyName }}
            </h1>
            <p class="text-surface-500">
              Nice to see you again, {{ auth.user?.firstname }}!
            </p>
          </div>
        </div>
        <div class="flex items-center gap-2">
          <Tag v-if="loadingScanCreditData" style="border: 2px solid"
               icon="fa-regular fa-camera-security"
               severity="secondary"
               value="CREDITS : ..."
               class="me-4"
          />
          <Tag v-else style="border: 2px solid"
               icon="fa-regular fa-camera-security"
               :severity="scanCreditsWarningLevelFormatting"
               :value="'CREDITS : ' + formattedScanCredits"
               class="me-4"
          >
            <template #icon>
              <LucideIcon name="Webcam" />
            </template>
          </Tag>
          <Button icon="fa fa-regular fa-bell text-xl" outlined severity="secondary">
            <template #icon>
              <LucideIcon name="Bell" />
            </template>
          </Button>
          <RouterLink to="/portal/user-guide">
            <Button outlined severity="secondary">
              <template #icon>
                <LucideIcon name="BookOpen" />
              </template>
            </Button>
          </RouterLink>
          <Button outlined severity="secondary" @click="ToggleDarkMode">
            <template #icon>
              <LucideIcon :name="iconForDarkModeToggle" />
            </template>
          </Button>
          <Button severity="danger" @click="logout">
            <template #icon>
              <LucideIcon name="LogOut" />
            </template>
          </Button>
        </div>
      </div>
      <div>
        <div class="w-full max-w-7xl mx-auto px-4">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import {ref, onMounted, onBeforeUnmount, computed} from 'vue';
import {useRouter} from 'vue-router';
import Pusher from 'pusher-js';
import api from '@/api';
import {useAuthStore} from '@/stores/auth';
import LucideIcon from "@/components/LucideIcon.vue";

let pusher;
let channels = [];

const auth = useAuthStore();
const router = useRouter();

const scanCreditsRemaining = ref(0);
const scanCreditsWarningLevel = ref(0);
const loadingScanCreditData = ref(true);

const formattedScanCredits = computed(() => {
  return scanCreditsRemaining.value.toLocaleString();
});

const scanCreditsWarningLevelFormatting = computed(() => {
  if (scanCreditsRemaining.value <= 0) {
    return 'danger';
  } else if (scanCreditsRemaining.value > 0 && scanCreditsRemaining.value <= scanCreditsWarningLevel.value) {
    return 'warn';
  } else {
    return 'success';
  }
});

const darkMode = ref(false);
const iconForDarkModeToggle = computed(() => (darkMode.value ? 'Moon' : 'Sun'));
const selectedNav = ref('Dashboard');
const selectedSubNav = ref({});

const navs = ref([]);

const selectNav = (label) => {
  const prevSelectedNav = selectedNav.value;
  selectedNav.value = label;

  // If the previous nav was a dropdown and we're switching away, reset its subnav
  const prevItem = navs.value.find(item => item.label === prevSelectedNav);
  if (prevItem?.subMenu) {
    const prevIndex = navs.value.findIndex(item => item.label === prevSelectedNav);
    if (prevIndex !== -1 && selectedNav.value !== prevSelectedNav) {
      selectedSubNav.value = {
        ...selectedSubNav.value,
        [prevIndex]: undefined // Clear the subnav for the previous dropdown
      };
    }
  }
};

const selectSubNav = (navIndex, subLabel) => {
  selectedSubNav.value = {
    ...selectedSubNav.value,
    [navIndex]: subLabel
  };
};

const getLinePath = (index, totalItems) => {
  if (index === 0) {
    return `M1 0 V40`;
  } else if (index === totalItems - 1) {
    return `M1 -4 V14`;
  } else {
    return `M1 -4 V40`;
  }
};

const getActiveLinePath = (index, selectedIndex) => {
  if (index === 0) {
    return `M1 0 V${index === selectedIndex ? '14' : '40'}`;
  } else if (index === selectedIndex) {
    return `M1 -4 V14`;
  } else {
    return `M1 -4 V40`;
  }
};

const getSelectedIndex = (navIndex) => {
  const currentNav = navs.value[navIndex];
  if (!currentNav?.subMenu || !selectedSubNav.value[navIndex]) return -1;
  return currentNav.subMenu.findIndex(
      (subItem) => subItem.label === selectedSubNav.value[navIndex]
  );
};

const ToggleDarkMode = () => {
  if (localStorage.getItem('dark_mode') === 'true') {
    localStorage.setItem('dark_mode', 'false');
    document.documentElement.classList.remove('my-app-dark');
  } else {
    localStorage.setItem('dark_mode', 'true');
    document.documentElement.classList.add('my-app-dark');
  }

  SetDarkModeIcon();
}

const SetDarkModeIcon = () => {
  darkMode.value = document.documentElement.classList.contains('my-app-dark');
}

const logout = async () => {
  try {
    await auth.logoutUser();

    // Navigate to login page
    await router.push({name: 'login'});
  } catch (error) {
    console.error('Logout failed:', error);
  }
}; 

onMounted(async () => {

  if (localStorage.getItem('dark_mode') === 'true') {
    document.documentElement.classList.add('my-app-dark');
  }
  SetDarkModeIcon();

  pusher = new Pusher(import.meta.env.VITE_PUSHER_KEY, {
    cluster: import.meta.env.VITE_PUSHER_CLUSTER,
    auth: {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}` // or your auth token
      }
    }});

  // Employee channel
  const employeeChannel = pusher.subscribe(`employee.${auth.user.employeeId}`);
  employeeChannel.bind('notification', (data) => {
    console.log('Employee notification:', data);
  });
  channels.push(employeeChannel);

  // Company channel
  const companyChannel = pusher.subscribe(`company.${auth.user.companyId}`);
  companyChannel.bind('scan-credits-updated', (data) => {
    const info = data.scanCreditData;
    scanCreditsRemaining.value = info.ScanCreditsRemaining;
    scanCreditsWarningLevel.value = info.ScanCreditsWarningLevel;
  });
  channels.push(companyChannel);


  // Build navs
  navs.value = auth.user.accessLevel === 'High' ? [
    {type: 'header', label: 'MANAGEMENT'},
    {icon: 'House', label: 'Dashboard', route: '/portal/dashboard'},
    {icon: 'Webcam', label: 'Credit Management', route: '/portal/credit-management'},
    {
      icon: 'BrickWall',
      label: 'Sites',
      route: '', // Top-level doesn’t route
      subMenu: [
        {label: 'Site Groups', route: '/portal/sitegroups'},
        {label: 'Site Management', route: '/portal/site'}
      ]
    },
    {
      icon: 'CircleUserRound',
      label: 'Workforce',
      route: '', // Top-level doesn’t route
      subMenu: [
        {label: 'Banned Accounts', route: '/portal/banned-accounts'},
        {label: 'Workforce Pool', route: '/portal/total-workforce-pool'}
      ]
    },
    {type: 'header', label: 'SITE OVERSIGHT'},
    {icon: 'Gauge', label: 'Advisory Panel', route: '/portal/site-dashboard'},
    {
      icon: 'Timer',
      label: 'Active Shifts',
      route: '/portal/site-active-shifts'
    },
    {icon: 'CircleUserRound', label: 'Assigned Staff', route: '/portal/site-workforce-pool'},
    {icon: 'ClipboardClock', label: 'DTR Logs', route: '/portal/site-dtr-logs'},
    {icon: 'HandCoins', label: 'Payroll Report', route: '/portal/site-payroll-report'},
    {icon: 'OctagonAlert', label: 'Validation Issues', route: '/portal/site-validation-issues'},
    {type: 'header', label: 'SYSTEM SETTINGS'},
    {
      icon: 'Cog',
      label: 'Configuration',
      route: '', // Top-level doesn’t route
      subMenu: [
        {label: 'Attributes', route: '/portal/attributes'},
        {label: 'Certifications', route: '/portal/certifications'},
        {label: 'Locations', route: '/portal/locations'},
        {label: 'Contractors', route: '/portal/contractors'},
        {label: 'Departments', route: '/portal/departments'},
        {label: 'Roles', route: '/portal/roles'},
        {label: 'Training & Courses', route: '/portal/training-courses'},
        {label: 'Work Shifts', route: '/portal/workshifts'},
      ]
    },
  ] : [
    {type: 'header', label: 'SITE INFORMATION'},
    {icon: 'Gauge', label: 'Advisory Panel', route: '/portal/site-dashboard'},
    {
      icon: 'Timer',
      label: 'Active Shifts',
      route: '/portal/site-active-shifts'
    },
    {icon: 'CircleUserRound', label: 'Assigned Staff', route: '/portal/site-workforce-pool'},
    {icon: 'ClipboardClock', label: 'DTR Logs', route: '/portal/site-dtr-logs'},
    {icon: 'OctagonAlert', label: 'Validation Issues', route: '/portal/site-validation-issues'}
  ];

  try {
    const scans = await api.get('company/scan-credits-data');
    scanCreditsRemaining.value = scans.data.scanCreditsRemaining;
    scanCreditsWarningLevel.value = scans.data.scanCreditsWarningLevel;
  } catch (err) {
    console.error(err);
  } finally {
    loadingScanCreditData.value = false;
  }

});

onBeforeUnmount(() => {
  channels.forEach((ch) => {
    ch.unbind_all();
    pusher.unsubscribe(ch.name);
  });

  // Check Pusher connection state before disconnecting
  if (pusher?.connection?.state === 'connected' || pusher?.connection?.state === 'connecting') {
    pusher.disconnect();
  }
});



</script>


<style scoped>
.overflow-y-auto {
  /* For webkit browsers like Chrome/Safari */

  &::-webkit-scrollbar {
    width: 4px; /* Reduced from 8px to 4px */
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    margin: 4px 0; /* Add some margin to top and bottom */
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.15); /* More subtle color */
    border-radius: 2px; /* Smaller radius */
  }

  /* Hide scrollbar when not scrolling (optional) */

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.25);
  }

  /* For Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
}

/* Dark mode styles */
:deep(.dark) .overflow-y-auto {
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.15);
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.25);
  }

  scrollbar-color: rgba(255, 255, 255, 0.15) transparent;
}
</style>
